import { createFileRoute, redirect } from "@tanstack/react-router";
import { BuildingsView } from "../../components/accommodation/buildings";
import { PageSkeleton } from "../../components/accommodation/page-skeleton";
import { canManageAccommodation, canSeeBuildings } from "../../lib/accommodation/access";
import { useDefaultGamesId } from "../../lib/competition/games";
import { canWriteFleet } from "../../lib/transport/access";

/** Buildings (her `#/acc/buildings`): the host's cards; a hotel sees its own, read-only. */
export const Route = createFileRoute("/_app/accommodation/buildings/")({
	beforeLoad: ({ context }) => {
		if (!canSeeBuildings(context.session)) throw redirect({ to: "/accommodation" });
	},
	component: BuildingsPage,
});

function BuildingsPage() {
	const { session } = Route.useRouteContext();
	const search = Route.useSearch();
	const gamesId = useDefaultGamesId(search.games_id);
	if (!gamesId) return <PageSkeleton />;
	return (
		<BuildingsView
			gamesId={gamesId}
			gamesIdInUrl={search.games_id}
			canManage={canManageAccommodation(session)}
			// Clusters and their drive minutes are the transport desk's (M10); shown here as in her prototype, to the same people.
			canEditClusters={canWriteFleet(session)}
		/>
	);
}
